import { DocumentListSection } from "../../../../../components/Proposal&Contracts/DocumentListSection.tsx"

export const defaultExclusions = [
  "Finish materials such as tiles, fixtures, appliances, cabinets, flooring, paint.",
  "Permit fees, design fees, or architectural drawings."
]

export function ContractExclusionsSection() {
  return (
    <DocumentListSection
      title="Exclusions"
      name="exclusions"
      itemPlaceholder="Exclusion item"
      addButtonText="Exclusion"
    />
  )
}
